export default __webpack_public_path__ + "static/media/illust_text_section1.66ae76fe.svg";